import Navbar from "../components/sections/Navbar";
import Hero from "../components/sections/Hero";
import Courses from "../components/sections/Courses";
import Memberships from "../components/sections/Memberships";
import ExtraAccess from "../components/sections/ExtraAccess";
import Book from "../components/sections/Book";
import Hypnodelics from "../components/sections/Hypnodelics";
import WelcomeVideo from "../components/sections/WelcomeVideo";
import Footer from "../components/sections/Footer";
import { Toaster } from "../components/ui/sonner";

export default function LandingPage() {
  return (
    <main
      data-testid="landing-page"
      className="relative bg-[#050505] text-[#F5F5F0] font-body overflow-x-hidden"
    >
      <Navbar />
      <Hero />
      <Courses />
      <Memberships />
      <ExtraAccess />
      <Book />
      <Hypnodelics />
      <WelcomeVideo />
      <Footer />
      <Toaster theme="dark" position="bottom-right" />
    </main>
  );
}
